// language.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private langSubject = new BehaviorSubject<string>('en');
  currentLang$ = this.langSubject.asObservable();

  setLang(lang: string) {
    this.langSubject.next(lang);
  }

  getLang(): string {
    return this.langSubject.value;
  }
}
